import { isMobile } from '@/lib/systemHelpers/browserHelpers';

export const PROPS = {
  token: 'dokkaToken',
  chatToken: 'chatToken',
  chatUser: 'chatUser',
  userId: 'userId',
  reactotronEnabled: 'reactotronEnabled',
  companyConfigurationVisited: 'companyConfigurationVisited',
  userGUID: 'userGUID',
  isDokkaSupport: 'isDokkaSupport',
  notesCreate: 'notesCreate',
  notesUpdate: 'notesUpdate',
  notesDelete: 'notesUpdate',
  splitOptions: 'splitOptions',
  workSpaceType: 'workSpaceType',
  companiesWorkSpaceType: 'companiesWorkSpaceType',
  tagsWidth: 'dokkaTagsWidth',
  docProportion: 'dokkaDocProportion',
  backUrl: 'BACKURL',
  jeActiveTab: 'DOKKA_JE_ACTIVE_TAB',
  insightsAgGridConfig: 'DOKKA_INSIGHTS_GRID_CONFIG_V2',
  emailSuggestion: 'emailSuggestion',
  workspaceAgGridConfig: 'DOKKA_WORKSPACE_GRID_CONFIG',
  workspaceAgGridPerPage: 'DOKKA_WORKSPACE_GRID_PER_PAGE',
  companiesAgGridConfig: 'DOKKA_COMPANIES_GRID_CONFIG',
  bankFeedTransactionsAgGridConfig: 'DOKKA_BANK_FEED_TRANSACTIONS_GRID_CONFIG_V2',
  paymentsAgGridConfig: 'PAY_PAYMENTS_GRID_CONFIG',
  paymentsAgGridPerPage: 'PAY_PAYMENTS_GRID_PER_PAGE',
  previousPaymentsAgGridConfig: 'PAY_PREVIOUS_PAYMENTS_GRID_CONFIG',
  previousPaymentsIsActive: 'PAY_PREVIOUS_PAYMENTS_IS_ACTIVE',
  paymentInvoicesTableConfig: 'PAY_PAYMENT_INVOICES_TABLE_CONFIG',
  payButtonOption: 'PAY_BUTTON_OPTION',
} as const;

type PropKey = keyof typeof PROPS;

type StorageValue = string | number | boolean;

type StorageField = {
  get: () => string | null;
  set: (v: StorageValue) => boolean;
  remove: () => boolean;
};

const st = isMobile ? window.sessionStorage : window.localStorage;

function getItem(key: string): string | null {
  return st.getItem(key);
}

function setItem(key: string, value: StorageValue): boolean {
  st.setItem(key, value.toString());
  return getItem(key) === value.toString();
}

function removeItem(key: string): boolean {
  st.removeItem(key);
  return getItem(key) === null;
}

export function storage(p: Record<string, string> = PROPS): Record<PropKey, () => StorageField> {
  const fields = Object.keys(p) as PropKey[];
  const methods = (name: string): StorageField => ({
    get: () => getItem(name),
    set: (v: StorageValue) => setItem(name, v),
    remove: () => removeItem(name),
  });
  return fields.reduce(
    (a, v) => Object.assign(a, { [v]: () => methods(PROPS[v]) }),
    {} as Record<PropKey, () => StorageField>,
  );
}

export function parseJSON(data: string | null) {
  if (data == null) return null;
  try {
    return JSON.parse(data);
  } catch (e) {
    console.error('parseJSON error', e);

    return null;
  }
}
